import { render, staticRenderFns } from "./AddNewRtbRule.vue?vue&type=template&id=b0aff5a2&"
import script from "./AddNewRtbRule.vue?vue&type=script&lang=js&"
export * from "./AddNewRtbRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports